import script from "./advance-salary-request.vue?vue&type=script&lang=ts&setup=true"
export * from "./advance-salary-request.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__